import { API_ENDPOINTS } from '../config/api';
import { getAuthHeaders, emitAuthExpired } from './api';
import { withUtmParams } from './utm';

function clearSessionOn401() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('auth_user');
  emitAuthExpired();
}

/**
 * Add poojas to cart. Requires JWT.
 * POST /api/cart with body { poojaDetailsIds: ["uuid1", "uuid2"], utm_source?, utm_medium?, utm_campaign? }
 */
export async function addToCart(poojaDetailsIds) {
  const ids = Array.isArray(poojaDetailsIds) ? poojaDetailsIds : [poojaDetailsIds];
  const validIds = ids.map((id) => id?.id ?? id?.poojaDetailsId ?? id).filter(Boolean);
  if (validIds.length === 0) return { success: false, message: 'No valid pooja IDs' };

  const body = withUtmParams({ poojaDetailsIds: validIds });
  const url = API_ENDPOINTS.cart;
  const res = await fetch(url, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (res.status === 401) {
    clearSessionOn401();
    throw new Error('Session expired. Please log in again to add to cart.');
  }
  if (!res.ok) {
    throw new Error(json?.message || json?.error || 'Failed to add to cart');
  }
  return json;
}

/**
 * Get cart items. Requires JWT.
 */
export async function getCart() {
  const url = API_ENDPOINTS.cart;
  const res = await fetch(url, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (res.status === 401) {
    clearSessionOn401();
    return [];
  }
  const data = await res.json().catch(() => ({}));
  return Array.isArray(data) ? data : data?.data ?? [];
}

/**
 * Remove item from cart. Requires JWT.
 * DELETE /api/cart/{cartItemId}
 */
export async function removeFromCart(cartItemId) {
  const url = API_ENDPOINTS.cartDelete(cartItemId);
  const res = await fetch(url, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (res.status === 401) {
    clearSessionOn401();
    throw new Error('Session expired. Please log in again.');
  }
  if (!res.ok) {
    throw new Error(json?.message || json?.error || 'Failed to remove from cart');
  }
  return json;
}
